// extracted by mini-css-extract-plugin
export default {"form":"styles_form__7Jm9R","button":"styles_button__N-6Rv","forgot-password":"styles_forgot-password__gvDht"};